import { render } from "./base-error-boundary.vue?vue&type=template&id=b47eb64a&ts=true"
import script from "./base-error-boundary.vue?vue&type=script&lang=ts"
export * from "./base-error-boundary.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__